var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { role: "dialog", "aria-modal": "true" }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(
                _vm._s(_vm.$t("maintenance.overview2d.markerAddModal.title"))
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "aria-label": "Close" },
                on: { click: _vm.dismiss }
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            )
          ]),
          _vm._v(" "),
          _vm.marker
            ? _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "small text-muted mb-2" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("maintenance.overview2d.marker.model.label")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.marker.label,
                        expression: "marker.label",
                        modifiers: { trim: true }
                      }
                    ],
                    ref: "input",
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.marker.label },
                    on: {
                      keydown: [
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          $event.preventDefault()
                          return _vm.save.apply(null, arguments)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape"
                            ])
                          )
                            return null
                          $event.preventDefault()
                          return _vm.dismiss.apply(null, arguments)
                        }
                      ],
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.marker,
                          "label",
                          $event.target.value.trim()
                        )
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "small text-muted mb-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("maintenance.overview2d.marker.model.cellId")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("vSelect", {
                      attrs: {
                        options: _vm.state.cellStore.cellsForVSelect,
                        label: "name",
                        reduce: cell => cell.id,
                        clearable: true
                      },
                      model: {
                        value: _vm.cellId,
                        callback: function($$v) {
                          _vm.cellId = $$v
                        },
                        expression: "cellId"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [_vm._v(_vm._s(_vm.$t("btnClose")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button", disabled: !_vm.canSave },
                on: { click: _vm.save }
              },
              [_vm._v(_vm._s(_vm.$t("btnAdd")))]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }